import DatePickerComponent from "./date/datePicker";
import RangePickerComponent from "./datepicker/RangePicker";
// import RangePicker from "./datepicker/RangePicker";
import Input from "./Input/Input";
import MultiSelect from "./multiSelect/multiSelect";
import MaskPassword from "./password/Password";
import RadioButtonsGroup from "./radioButton/radioButton";
import Selects from "./select/selectInput";

export default function FieldsGetter({ props }) {
    const { type } = props

    switch (type) {
        case 'select':
            return <Selects {...props} />

        case 'text':
            return <Input type="text" {...props} />

        case "radio":
            return <RadioButtonsGroup {...props} />

        case 'number':
            return (
                <Input
                    defaultValue={1}
                    min={1}
                    type="number"
                    {...props}
                />
            )

        case 'dateRange':
            return <RangePickerComponent {...props} />

        case 'date':
            return <DatePickerComponent {...props} />

        case 'multiSelect':
            return <MultiSelect {...props} />

        case 'password':
            return <MaskPassword {...props} />
    }
}